import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {CommonUtils} from "../../utils/common";
import {environment} from "../../../environments/environment";
import {DaySettings} from "../../models/day-settings.model";

@Component({
  selector: 'app-advanced-day-setting',
  templateUrl: './advanced-day-setting.component.html',
  styleUrls: ['./advanced-day-setting.component.scss'],
})
export class AdvancedDaySettingComponent implements OnInit {
  @Input() daySettings: DaySettings;
  @Output() addedReservationJsonEmitter: EventEmitter<DaySettings> = new EventEmitter<DaySettings>();
  @Output() cancelReservationJsonEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();
  daySettingsGroup: FormGroup;
  isBusy: any;

  constructor(public commonUtils: CommonUtils,
              private formBuilder: FormBuilder) {
  }

  ngOnInit() {
    this.daySettingsGroup = this.formBuilder.group({
      startTime: [this.daySettings.startTime, [Validators.required, Validators.pattern(environment.TIME_REGEXP_PATTERN)]],
      endTime: [this.daySettings.endTime, [Validators.required, Validators.pattern(environment.TIME_REGEXP_PATTERN)]],
    });
  }

  onBlur(controlType: string): void {
    if (controlType === 'start') {
      let startTime = this.daySettingsGroup.controls.startTime.value;
      if (startTime.split(':')?.length === 1) {
        this.daySettingsGroup.controls.startTime.setValue(startTime + ":00");
      }


    } else {
      let endTime = this.daySettingsGroup.controls.endTime.value;
      if (endTime.split(':')?.length === 1) {
        this.daySettingsGroup.controls.endTime.setValue(endTime + ":00");
      }
    }
  }

  onSave() {
    if (this.daySettingsGroup.valid) {
      let obj: DaySettings = this.commonUtils.formGroupValuesToObject<DaySettings>(new DaySettings(), this.daySettingsGroup);
      if (obj.startTime.split(':')[0]?.length === 1) {
        obj.startTime = 0 + obj.startTime;
      }
      if (obj.endTime.split(':')[0]?.length === 1) {
        obj.endTime = 0 + obj.endTime;
      }
      obj.day = this.daySettings.day;
      obj.isFullDay = false;
      this.addedReservationJsonEmitter.emit(obj);
    } else {
      this.commonUtils.presentAlertToast('Błędny format czasu');
    }
  }

  onCancel() {
    this.cancelReservationJsonEmitter.emit(true);
  }

  markUnsavedChanges() {

  }
}
